"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _TextContent = _interopRequireDefault(require("./TextContent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextAttachment = function TextAttachment(_ref) {
  var _ref$attachment = _ref.attachment;
  _ref$attachment = _ref$attachment === void 0 ? {} : _ref$attachment;
  var _ref$attachment$conte = _ref$attachment.content,
      content = _ref$attachment$conte === void 0 ? '' : _ref$attachment$conte,
      contentType = _ref$attachment.contentType;
  return /*#__PURE__*/_react.default.createElement(_TextContent.default, {
    contentType: contentType,
    text: content
  });
};

TextAttachment.propTypes = {
  attachment: _propTypes.default.shape({
    content: _propTypes.default.string,
    contentType: _propTypes.default.string.isRequired
  }).isRequired
};
var _default = TextAttachment;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9BdHRhY2htZW50L1RleHRBdHRhY2htZW50LmpzIl0sIm5hbWVzIjpbIlRleHRBdHRhY2htZW50IiwiYXR0YWNobWVudCIsImNvbnRlbnQiLCJjb250ZW50VHlwZSIsInByb3BUeXBlcyIsIlByb3BUeXBlcyIsInNoYXBlIiwic3RyaW5nIiwiaXNSZXF1aXJlZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUNBOztBQUVBOzs7O0FBRUEsSUFBTUEsY0FBYyxHQUFHLFNBQWpCQSxjQUFpQjtBQUFBLDZCQUFHQyxVQUFIO0FBQUEsaURBQStDLEVBQS9DO0FBQUEsOENBQWlCQyxPQUFqQjtBQUFBLE1BQWlCQSxPQUFqQixzQ0FBMkIsRUFBM0I7QUFBQSxNQUErQkMsV0FBL0IsbUJBQStCQSxXQUEvQjtBQUFBLHNCQUNyQiw2QkFBQyxvQkFBRDtBQUFhLElBQUEsV0FBVyxFQUFFQSxXQUExQjtBQUF1QyxJQUFBLElBQUksRUFBRUQ7QUFBN0MsSUFEcUI7QUFBQSxDQUF2Qjs7QUFJQUYsY0FBYyxDQUFDSSxTQUFmLEdBQTJCO0FBQ3pCSCxFQUFBQSxVQUFVLEVBQUVJLG1CQUFVQyxLQUFWLENBQWdCO0FBQzFCSixJQUFBQSxPQUFPLEVBQUVHLG1CQUFVRSxNQURPO0FBRTFCSixJQUFBQSxXQUFXLEVBQUVFLG1CQUFVRSxNQUFWLENBQWlCQztBQUZKLEdBQWhCLEVBR1RBO0FBSnNCLENBQTNCO2VBT2VSLGMiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgVGV4dENvbnRlbnQgZnJvbSAnLi9UZXh0Q29udGVudCc7XG5cbmNvbnN0IFRleHRBdHRhY2htZW50ID0gKHsgYXR0YWNobWVudDogeyBjb250ZW50ID0gJycsIGNvbnRlbnRUeXBlIH0gPSB7fSB9KSA9PiAoXG4gIDxUZXh0Q29udGVudCBjb250ZW50VHlwZT17Y29udGVudFR5cGV9IHRleHQ9e2NvbnRlbnR9IC8+XG4pO1xuXG5UZXh0QXR0YWNobWVudC5wcm9wVHlwZXMgPSB7XG4gIGF0dGFjaG1lbnQ6IFByb3BUeXBlcy5zaGFwZSh7XG4gICAgY29udGVudDogUHJvcFR5cGVzLnN0cmluZyxcbiAgICBjb250ZW50VHlwZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkXG4gIH0pLmlzUmVxdWlyZWRcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFRleHRBdHRhY2htZW50O1xuIl19